// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const PhonePure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M9.988 8.835a2.22 2.22 0 0 0-1.78 2.136l-.094-.099-.002.012C5.932 9.64 4.168 7.701 3.089 5.35h.2a2.22 2.22 0 0 0 2.042-1.349L2.829 0l-.901.026A8.663 8.663 0 0 0 .005 1.588C.002 1.693 0 1.8 0 1.91c0 6.665 5.02 12.1 11.317 12.39l.022-.016c.102.01.204.017.306.017.11 0 .217-.003.322-.005a8.674 8.674 0 0 0 1.563-1.923l.031-1.107-3.573-2.43z"
    />
  </svg>,
);

export const PhoneIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <PhonePure className={props.iconClassName} />
);

PhoneIcon.displayName = 'PhoneIcon';
